"use strict";exports.filterProps=(r,e)=>Object.fromEntries(Object.entries(r).filter((r=>{let[t]=r;return Array.isArray(e)?e.every((r=>r!==t)):t!==e})));
